$(() => {

  let image = $('.image');
  let imageMobile = $('.image .img-mobile');
  let formBusiness = $('.form-business');
  let ucrPassword = $('#ucr_password');
  let ucrPasswordConfirm = $('#ucr_password_confirmation');

  $('input[name=option]').on('click', function(e){
    let el = $(this);
    let val = el.val();

    if (val == 'business') {
      formBusiness.show();
      image.css('background-image', 'url(/img/bg-register-business.png)');
      imageMobile.attr('src','/img/bg-register-business.png');
      ucrPassword.attr('placeholder', 'Nueva contraseña');
      ucrPasswordConfirm.attr('placeholder', 'Repetir nueva contraseña');
    } else {
      formBusiness.hide();
      image.css('background-image', 'url(/img/bg-register.png)');
      imageMobile.attr('src','/img/bg-register.png');
      ucrPassword.attr('placeholder', 'Contraseña');
      ucrPasswordConfirm.attr('placeholder', 'Repetir contraseña');
    }
  })
})
